<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-cogs"></i> Configuración
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-outline-primary" @click="activarDiv()"><i class="fas fa-edit"></i>Editar</button>

                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->
                        <form :class="[edit == false ? 'bloquear' : '']" >

                            <ul class="nav nav-tabs nav-bordered">
                                <li class="nav-item">
                                    <a href="#datos-gen" data-toggle="tab" aria-expanded="false" class="nav-link active">
                                        Datos Generales
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#img-general" data-toggle="tab" aria-expanded="true" class="nav-link">
                                        Imagenes Generales
                                    </a>
                                </li>

                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane show active" id="datos-gen">
                                    <div class="row">
                                    <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Título de la Página</label>
                                                <input type="text"  class="form-control" id="titulo" v-model="vaCreConfig.titulo_pagina" placeholder="Ingrese Titulo de la pagina">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Cabecera PDF</label>
                                                <input type="text"  class="form-control" id="cabecera" v-model="vaCreConfig.titulo_pdf"  placeholder="Ingrese Cabecera del PDF">
                                            </div>
                                        </div>
                                        <div class="col-md-6" >
                                                <div class="form-group">
                                                    <label for="">Iva -Igv </label>
                                                    <input type="number"  class="form-control" id="iva" v-model="vaCreConfig.iva" >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Pie de Pagina PDF</label>
                                                    <input type="text"  class="form-control" id="cabecera" v-model="vaCreConfig.pie_pdf"  placeholder="Ingrese Pie de Pagina PDF">
                                                </div>
                                            </div>
                                            <div class="col-md-6" >
                                                <div class="form-group">
                                                    <label for="">Corre Electronico</label>
                                                    <input type="text"  class="form-control" id="direccion" v-model="vaCreConfig.email"  placeholder="Ingrese N° Telefono">

                                                </div>
                                            </div>

                                            <div class="col-md-6" >
                                                <div class="form-group">
                                                    <label for="" class="mr-2">Telefono</label>
                                                    <input type="text"  class="form-control" id="direccion" v-model="vaCreConfig.telefono"  placeholder="Ingrese N° Telefono">
                                                </div>
                                            </div>

                                            <div class="col-md-12" >
                                                <div class="form-group">
                                                    <label for="">Dirección</label>
                                                <input type="text"  class="form-control" id="direccion" v-model="vaCreConfig.direccion" placeholder="Ingrese Dirección">

                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="tab-pane" id="img-general">
                                    <div class="row" id="form-config">
                                        <div class="form-group col-md-4 col-lg-4 col-xl-3" align="center">
                                                <div class="kv-avatar">
                                                    <label for="text-input">Logo 1 Sidebar:</label>
                                                    <input vue-load-image   @change="obtenerImagenS1" name="img_s" type="file" data-msg-placeholder="Seleccione una imagen"  class="form-control" id="img_s" accept="image/*">
                                                </div>
                                        </div>
                                        <div class="form-group col-md-4 col-lg-4 col-xl-3" align="center">
                                                <div class="kv-avatar">
                                                    <label for="text-input">Logo 2 Sidebar:</label>
                                                    <input vue-load-image   @change="obtenerImagenS2" name="img_l" type="file" data-msg-placeholder="Seleccione una imagen"  class="form-control" id="img_l" accept="image/*">
                                                </div>
                                        </div>

                                        <div class="form-group col-md-4 col-lg-4 col-xl-3"  align="center">
                                                <div class="kv-avatar">
                                                    <label for="text-input">Logo PDF:</label>
                                                    <input vue-load-image   @change="obtenerImagenPDF" name="img_v"  type="file" data-msg-placeholder="Seleccione una imagen"  class="form-control" id="img_v" accept="image/*">
                                                </div>
                                        </div>

                                        <div class="form-group col-md-4 col-lg-4 col-xl-3"  align="center">
                                                <div class="kv-avatar">
                                                    <label for="text-input">Icon Web:</label>
                                                    <input vue-load-image @change="obtenerImagenI" name="img_i" type="file" data-msg-placeholder="Seleccione una imagen"  class="form-control" id="img_i" accept="image/*">
                                                </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                        <div class="form-group row">
                        <!--  <button type="button"  class="btn btn-primary" @click="actualizarConfig()">Guardar</button> -->
                            <button class="btn btn-success btn-block " @click="actualizarConfig()" v-if="edit"  type="button">Guardar</button>
                        </div>

                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>


    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {

data() {
    return {
        edit: false,
        //configuracion: JSON.parse(localStorage.getItem('listarConfig')),
        vaCreConfig:{
                        config_id: 0,
                        titulo_pagina: "",
                        titulo_pdf: "",
                        pie_pdf: "",
                        iva: 0.0,
                        direccion: "",
                        telefono: "",
                        email: "",
                        logo_1: '',
                        logo_2: '',
                        logo_pdf: '',
                        favicon_img: '',
                },
        form: new FormData,

    }
},
mixins: [alertasM],
methods: {
            obtenerImagenS1(e){
                let file =  e.target.files[0]
                this.vaCreConfig.logo_1 = file
               // console.log(this.img);
            },
            obtenerImagenS2(e){
                let file =  e.target.files[0]
                this.vaCreConfig.logo_2 = file
               // console.log(this.img);
            },
            obtenerImagenPDF(e){
                let file =  e.target.files[0]
                this.vaCreConfig.logo_pdf = file
               // console.log(this.img);
            },
            obtenerImagenI(e){
                let file =  e.target.files[0]
                this.vaCreConfig.favicon_img = file
               // console.log(this.img);
            },
            activarDiv(){
                  let me = this;
                  me.edit = !me.edit;

            },

            cargarDatos(operacion){

                this.openCargando();
                var ruta = '/config'
                axios.get(ruta)
                .then(res => {

                    var respuesta = res.data.config[0];

                    this.vaCreConfig.config_id = respuesta.id;
                    this.vaCreConfig.titulo_pagina = respuesta.titulo_pagina;
                    this.vaCreConfig.titulo_pdf = respuesta.titulo_pdf;
                    this.vaCreConfig.pie_pdf = respuesta.pie_pdf;
                    this.vaCreConfig.iva = respuesta.iva;
                    this.vaCreConfig.direccion = respuesta.direccion;
                    this.vaCreConfig.telefono = respuesta.telefono;
                    this.vaCreConfig.email = respuesta.email;
                    this.vaCreConfig.logo_1 = respuesta.logo_1;
                    this.vaCreConfig.logo_2 = respuesta.logo_2;
                    this.vaCreConfig.logo_pdf = respuesta.logo_pdf;
                    this.vaCreConfig.favicon_img = respuesta.favicon_img;
                    if(operacion==1){

                        document.getElementById("logo_s").src = "storage/config/"+ this.vaCreConfig.logo_1;
                        document.getElementById("logo_v").src = "storage/config/"+  this.vaCreConfig.logo_2;
                        document.getElementById("logo_i").src = "storage/config/"+ this.vaCreConfig.logo_pdf;
                        document.getElementById("logo_l").src = "storage/config/"+ this.vaCreConfig.favicon_img;

                    }
                    this.openCargando(true);
                    this.activarDiv();
                })
                .catch(err => {
                      if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                                }
                        console.error(err);
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                })


            },

            actualizarConfig() {
                let me = this;
                me.openCargando();
                var url = '/configuracion/actualizar';

                var da = new FormData();
                me.form.append('config_id', me.vaCreConfig.config_id);
                me.form.append('titulo_pagina', me.vaCreConfig.titulo_pagina );
                me.form.append('titulo_pdf',  me.vaCreConfig.titulo_pdf);
                me.form.append('pie_pdf',  me.vaCreConfig.pie_pdf);
                me.form.append('iva',  me.vaCreConfig.iva);
                me.form.append('direccion', me.vaCreConfig.direccion);
                me.form.append('telefono', me.vaCreConfig.telefono);
                me.form.append('email', me.vaCreConfig.email);
                me.form.append('logo_1', me.vaCreConfig.logo_1);
                me.form.append('logo_2', me.vaCreConfig.logo_2);
                me.form.append('logo_pdf', me.vaCreConfig.logo_pdf);
                me.form.append('favicon_img', me.vaCreConfig.favicon_img);
                const config = { headers: { 'Content-Type': 'multipart/form-data'}}//Aceptamos archivos
                //da.append('idcategoria', me.idcategoria);

                axios.post(url, me.form, config).then(function(response) {

                      if(response.data.status){
                        me.openCargando(true);

                        me.getRefrescarConfiguracion();
                        me.notify(" Configuracion registrada con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX');
                        me.form = new FormData;
                     }
                     me.cargarDatos(0);
                    })
                    .catch(function(error) {
                        console.error(error);
                       let me = this;
                       me.openCargando(true);//Desactivamos ventana de carga de bloqueo

                            if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                                }
                        console.error(err);
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo


                    });
            },

            getRefrescarConfiguracion(){
                var ruta = '/config'
                axios.get(ruta)
                .then(res => {

                    EventBus.$emit('verifyConfig',res.data.config[0]);
                })
                .catch(err => {
                     if (err.response.status == 401) {
                                if (localStorage['authUser']) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                                }
                                }
                        console.error(err);
                        this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                })
            }



},
mounted() {
    this.cargarDatos(1);
    $(document).ready(function(){

                $('#img_s').fileinput({
                language: 'es',
                        allowedFileExtensions:['jpeg','jpg','png'],
                        maxFileSize: 8000,//8mb
                        showUpload:false,
                        showClose: false,
                        dropZoneEnabled: false,
                        browseLabel: '',
                        removeLabel: '',
                        browseIcon: '<i class="fas fa-folder-open"></i>',
                        removeIcon: '<i class="fas fa-trash-alt"></i>',
                        overwriteInitial: true,showCaption: false,

                        theme: "fa",
                        defaultPreviewContent:'<img id="logo_s" class="center img-thumbnail blanco"   src="img/no-image.png" >',
                });
                $('#img_v').fileinput({
                language: 'es',
                        allowedFileExtensions:['jpeg','jpg','png'],
                        maxFileSize: 8000,//8mb
                        showUpload:false,
                        showClose: false,
                        dropZoneEnabled: false,
                        browseLabel: '',
                        removeLabel: '',
                        browseIcon: '<i class="fas fa-folder-open"></i>',
                        removeIcon: '<i class="fas fa-trash-alt"></i>',
                        overwriteInitial: true,showCaption: false,
                        /*
                        showRemove: true,

                        initialPreviewAsData:true,
                        */
                        theme: "fa",
                         defaultPreviewContent:'<img id="logo_v" class="center img-thumbnail"   src="img/no-image.png">',
                });
                $('#img_i').fileinput({
                language: 'es',
                        allowedFileExtensions:['jpeg','jpg','png'],
                        maxFileSize: 8000,//8mb
                        showUpload:false,
                        showClose: false,
                        dropZoneEnabled: false,
                        browseLabel: '',
                        removeLabel: '',
                        browseIcon: '<i class="fas fa-folder-open"></i>',
                        removeIcon: '<i class="fas fa-trash-alt"></i>',
                        overwriteInitial: true,showCaption: false,
                        /*
                        showRemove: true,

                        initialPreviewAsData:true,
                        */
                        theme: "fa",
                    defaultPreviewContent:'<img id="logo_i" class="center img-thumbnail"   src="img/no-image.png">',
                });

                    $('#img_l').fileinput({
                    language: 'es',
                            allowedFileExtensions:['jpeg','jpg','png'],
                            maxFileSize: 8000,//8mb
                            showUpload:false,
                            showClose: false,
                            dropZoneEnabled: false,
                            browseLabel: '',
                            removeLabel: '',
                            browseIcon: '<i class="fas fa-folder-open"></i>',
                            removeIcon: '<i class="fas fa-trash-alt"></i>',
                            overwriteInitial: true,showCaption: false,
                            /*
                            showRemove: true,

                            initialPreviewAsData:true,
                            */
                            theme: "fa",
                        defaultPreviewContent:'<img id="logo_l" class="center img-thumbnail"   src="img/no-image.png">',
                    });

                });

    },
}
</script>

<style>

</style>
